// extracted by mini-css-extract-plugin
export var avatarContainer = "_6a-0";
export var avatarTypingWave = "_6a-i";
export var gray = "_6a-f";
export var green = "_6a-c";
export var icon = "_6a-9";
export var image = "_6a-1";
export var lg = "_6a-6";
export var md = "_6a-5";
export var presenceDot = "_6a-b";
export var red = "_6a-d";
export var sm = "_6a-4";
export var status = "_6a-a";
export var typingDot = "_6a-h";
export var typingPill = "_6a-g";
export var xl = "_6a-7";
export var xs = "_6a-3";
export var xxl = "_6a-8";
export var xxs = "_6a-2";
export var yellow = "_6a-e";